import tlds from 'tlds'

import { isDevelopment } from 'utils/nodeEnv'
import { REACT_APP_BLAZE } from 'env'

import { UserRole } from 'types'
import StyleVariables from './styles.module.scss'

export const scrollToPadding = 200

export const codeLanguageOptions = [
  { label: 'Plain Text', value: '' },
  { label: 'Clojure', value: 'clojure' },
  { label: 'Common Lisp', value: 'commonlisp' },
  { label: 'Crystal', value: 'crystal' },
  { label: 'CSS', value: 'css' },
  { label: 'D', value: 'd' },
  { label: 'Dart', value: 'dart' },
  { label: 'Diff', value: 'diff' },
  { label: 'Dockerfile', value: 'dockerfile' },
  { label: 'Elm', value: 'elm' },
  { label: 'Erlang', value: 'erlang' },
  { label: 'FCL', value: 'fcl' },
  { label: 'Go', value: 'go' },
  { label: 'Groovy', value: 'groovy' },
  { label: 'Haml', value: 'haml' },
  { label: 'Handlebars', value: 'handlebars' },
  { label: 'Haskell', value: 'haskell' },
  { label: 'HTML', value: 'html' },
  { label: 'JavaScript', value: 'javascript' },
  { label: 'JSX', value: 'jsx' },
  { label: 'Julia', value: 'julia' },
  { label: 'Lua', value: 'lua' },
  { label: 'Markdown', value: 'markdown' },
  { label: 'Mathematica', value: 'mathematica' },
  { label: 'nginx', value: 'nginx' },
  { label: 'Pascal', value: 'pascal' },
  { label: 'Perl', value: 'perl' },
  { label: 'PHP', value: 'php' },
  { label: 'Pig', value: 'pig' },
  { label: 'Powershell', value: 'powershell' },
  { label: 'Puppet', value: 'puppet' },
  { label: 'Python', value: 'python' },
  { label: 'R', value: 'r' },
  { label: 'ReST', value: 'rst' },
  { label: 'Ruby', value: 'ruby' },
  { label: 'Rust', value: 'rust' },
  { label: 'Sass', value: 'sass' },
  { label: 'Scheme', value: 'scheme' },
  { label: 'Shell', value: 'shell' },
  { label: 'Smalltalk', value: 'smalltalk' },
  { label: 'Spreadsheet', value: 'spreadsheet' },
  { label: 'SQL', value: 'sql' },
  { label: 'Swift', value: 'swift' },
  { label: 'Tcl', value: 'tcl' },
  { label: 'Textile', value: 'textile' },
  { label: 'TOML', value: 'toml' },
  { label: 'Turtle', value: 'turtle' },
  { label: 'VB', value: 'vb' },
  { label: 'VBScript', value: 'vbscript' },
  { label: 'Vue', value: 'vue' },
  { label: 'XML', value: 'xml' },
  { label: 'XQuery', value: 'xquery' },
  { label: 'YAML', value: 'yaml' },
]

export const MODALS = {
  IMPORT_MODAL: 'IMPORT_MODAL',
  UPLOAD_MODAL: 'UPLOAD_MODAL',
  PREVIEW_MODAL: 'PREVIEW_MODAL',
  PROCESSING_UPLOAD_MODAL: 'PROCESSING_UPLOAD_MODAL',
  SIGNUP_MODAL: 'SIGNUP_MODAL',
  TEAM_MODAL: 'TEAM_MODAL',
  INVITE_MODAL: 'INVITE_MODAL',
  WORKSPACE_MODAL: 'WORKSPACE_MODAL',
}

export const supportedElementTypes = ['Header', 'Copy', 'Code', 'Download', 'Image', 'Quote', 'Table']

const isBlaze = REACT_APP_BLAZE === true

export const APP_ROOT_PATH = isBlaze ? 'https://app.blaze.ai' : 'https://www.almanac.io'
export const CAREERS_PATH = isBlaze ? 'https://get.blaze.ai/careers' : 'https://get.almanac.io/careers'
export const PUBLISH_INFO_PATH = '/docs/get-started-with-publishing-on-almanac-92400e87412d8c2b98b0af8c086dd088'
export const PRIVACY_PATH = isBlaze ? 'https://get.blaze.ai/privacy-policy' : 'https://get.almanac.io/privacy-policy'
export const TERMS_PATH = isBlaze ? 'https://get.blaze.ai/terms' : 'https://get.almanac.io/terms'

export const APP_DEVELOPMENT_HOSTNAME = 'localhost'
export const HOSTNAME = isBlaze ? 'blaze.ai' : 'almanac.io'
export const ALMANAC_LEGACY_HOSTNAME = 'askalmanac.com'
export const HOSTNAMES = isDevelopment()
  ? [HOSTNAME, ALMANAC_LEGACY_HOSTNAME, APP_DEVELOPMENT_HOSTNAME]
  : [HOSTNAME, ALMANAC_LEGACY_HOSTNAME]
export const MAX_CONTRIBUTORS_DISPLAY = 5
export const TWITTER_URL = isBlaze ? 'https://twitter.com/blazeaiapp' : 'https://twitter.com/AlmanacDocs'
export const TWITTER_HANDLE = isBlaze ? '@blazeaiapp' : '@AlmanacDocs'
export const LINKEDIN_URL = isBlaze
  ? 'https://www.linkedin.com/company/blaze-ai'
  : 'https://www.linkedin.com/company/almanacdocs'
export const INVESTORS_URL = isBlaze ? 'https://get.blaze.ai/investors' : 'https://get.almanac.io/investors'
export const CHANGELOG_URL = 'https://almanac.io/changelog'
export const LAYERS_HELP_DOC = 'https://helpcenter.almanac.io/learn/layers-S2heNzwWqfQl2bEByJIB3XJdjsJzM8af'
export const HELP_CENTER_URL = isBlaze ? 'https://help.blaze.ai' : 'https://helpcenter.almanac.io/learn'
export const HELP_CENTER_WHAT_IS_ALMANAC_URL = isBlaze
  ? 'https://blazehelpcenter.almanac.io/folders/blaze-help-center-M8z9eD/what-is-blaze-WX4zAMoFqvPE9ujyTgNFtalRT4C0AJlT'
  : 'https://helpcenter.almanac.io/learn/what-is-almanac-oDLTJ4gcnto9uCO6g8juwhUVgR3p92Lb'
export const HELP_CENTER_LEARN_REVIEWS_URL = isBlaze
  ? 'https://blazehelpcenter.almanac.io/folders/blaze-help-center-M8z9eD/reviews-20230915-RzuaGDg9ATJCFPlB6v4BAE73a1gxBa98'
  : 'https://helpcenter.almanac.io/learn/reviews-UbTuU3hjRcm9fUqIUfVm2qqLMNDvisyb'
export const HELP_CENTER_REVIEW_AND_APPROVAL_REQUESTS_URL = 'https://help.blaze.ai/en/articles/9585765-share-for-review'
export const HELP_CENTER_COMMENTS_AND_TASKS_URL = 'https://help.blaze.ai/en/articles/9580565-comments-and-tasks'
export const HELP_CENTER_IMPORT_HELP_DOC = isBlaze
  ? 'https://blazehelpcenter.almanac.io/folders/blaze-help-center-M8z9eD/import-documents-7gC0I2eOdeWGVYqnPBygu2n6FpZBmjqI'
  : 'https://helpcenter.almanac.io/learn/import-documents-RPK7sG53J5HIs5oAYimGx7zEAf4GQdKk'

export const PRODUCT_TOUR_URL = 'https://www.loom.com/share/db06329562bd4dfc903317d0380b2728' // Almanac specific; not currently in use
export const ABOUT_URL = isBlaze ? 'https://get.blaze.ai/about' : 'https://get.almanac.io/about'
export const SUPPORT_EMAIL = isBlaze ? 'support@blaze.ai' : 'support@almanac.io'
export const ZERO_WIDTH_SPACING = ''
export const BLAZE_BLACK_LOGO = 'https://res.cloudinary.com/almanac/image/upload/v1695141551/BlazeBlackBg_ldowww.svg'
export const LOGO_URL = isBlaze
  ? 'https://res.cloudinary.com/almanac/image/upload/v1693415004/BlazeLogo_sndkkp.png'
  : 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1647525925/public/shared-link-logo_wvkyni.png'
export const BRAND_VOICE_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1695307980/blaze_assets/voice_wg7pqp.png'
export const BRAINSTORM_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1695319052/blaze_assets/image_195_wrgzqs.png'

export const BRAND_VOICE_CTA_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1695767198/blaze_assets/CTA/Brand-Voice_1_y19yua.png'
export const BRAINSTORM_CTA_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1695767198/blaze_assets/CTA/Brainstorm_1_qheq5c.png'
export const CAMPAIGN_CREATE_CTA_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1695767198/blaze_assets/CTA/Campaign_1_rova9v.png'
export const INTEGRATIONS_CTA_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1695767198/blaze_assets/CTA/Integrations_1_tqxraa.png'

export const BRAND_VOICE_CTA_IMAGE_URL_SMALL =
  'https://res.cloudinary.com/almanac/image/upload/v1695832899/blaze_assets/CTA/brand-voice_hejymt.png'
export const BRAINSTORM_CTA_IMAGE_URL_SMALL =
  'https://res.cloudinary.com/almanac/image/upload/v1695832898/blaze_assets/CTA/brainstorm_lvwnhq.png'
export const CAMPAIGN_CREATE_CTA_IMAGE_URL_SMALL =
  'https://res.cloudinary.com/almanac/image/upload/v1695832897/blaze_assets/CTA/create-campaign_aeq6jw.png'
export const INTEGRATIONS_CTA_IMAGE_URL_SMALL =
  'https://res.cloudinary.com/almanac/image/upload/v1695832900/blaze_assets/CTA/integrations_arq3sc.png'

export const BLACK_FRIDAY_CTA_IMAGE_URL =
  'https://res.cloudinary.com/almanac/image/upload/v1699390826/blaze_assets/CTA/blackfriday_ude8ih.png'
export const BLACK_FRIDAY_CTA_IMAGE_URL_SMALL =
  'https://res.cloudinary.com/almanac/image/upload/v1699888163/blaze_assets/CTA/60209bca028d122ff0593e81b7ee54a4_nwfnew.png'

export const PREVIEW_IMAGE_HEIGHT = 630
export const PREVIEW_IMAGE_WIDTH = 1200
export const ALMANAC_CORE_WORKSPACE_ID = 1
export const APP_HELPCENTER_WORKSPACE_ID = 55793
export const BLAZE_HELPCENTER_WORKSPACE_ID = 94219
export const ALMANAC_CORE_WORKSPACE = {
  id: 1,
  name: 'Almanac Core',
  created_at: '2019-01-01T00:00:00',
  key: '3295e2f0e3',
  homepage_doc_slug: null,
  homepage_doc: null,
  logo_url: 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1575476696/almanac_logo.png',
  unpaid_articles_count: 0,
  admin: false,
  super_admin: false,
  paying: false,
  invitation_token: 'almanac-2f4d19',
  invitation_token_enabled: false,
  invitation_token_expiration_days: 7,
  snippets_enabled: false,
  show_portal: false,
  show_make_public: false,
  is_new: false,
  guest: false,
  role: UserRole.MEMBER,
  show_all_handbooks: false,
  handbook_default_read_mode: false,
  workspace_domain: null,
  members_count: 0,
  guest_articles_count: 0,
  payment_failed: false,
  auto_membership_domains: [],
  features: [],
  version_control_mode: {
    value: false,
    metadata: null,
  },
  allow_public_links: true,
  documentation_enabled: true,
  layers_enabled: true,
  can_start_free_trial: false,
  color_scheme: null,
  app_logo_url: null,
  is_virtual_marketer: false,
  is_virtual_marketer_onboarding_completed: false,
  virtual_marketer_onboarding_completed_at: null,
  show_virtual_marketer_upgrade: false,
  pause_autopilot_generate_at: null,
  pause_autopilot_publish_at: null,
  resume_autopilot_generate_at: null,
  resume_autopilot_publish_at: null,
  post_approval_enabled: false,
  is_ap_freemium: false,
  is_ap_freemium_brand_plan_set: false,
  is_campaigns: false,
  is_whitelabel: false,
  white_label_color: null,
  auto_reload_credits: false,
  auto_reload_limit: null,
  is_ads_testing_enabled: false,
}

export const JOB_AVAILABILITY_OPTIONS = [
  { label: 'Available for hire', key: 'available_for_hire', value: true },
  { label: 'Remote', key: 'can_remote', value: true },
  { label: 'Willing to relocate', key: 'can_relocate', value: true },
  { label: 'Available to mentor', key: 'can_mentor', value: true },
]

export const JOB_TYPE_OPTIONS = [
  { label: 'Full-Time', key: 'full_time_work_search', value: true },
  { label: 'Contract / Consultancy', key: 'contractor_work_search', value: true },
]

export const JOB_EXPERIENCE_OPTIONS = [
  { label: 'Entry Level (1-2 years)', key: 'experience_level_0', value: 'entry' },
  { label: 'Junior (1-2 years)', key: 'experience_level_1', value: 'junior' },
  { label: 'Senior', key: 'experience_level_2', value: 'senior' },
  { label: 'Manager', key: 'experience_level_3', value: 'manager' },
  { label: 'Executive', key: 'experience_level_4', value: 'executive' },
]

export const NO_FOLDER_TITLE = 'Projects'
export const PERSONAL_TITLE = 'Personal'
export const DEFAULT_FOLDER_DISABLED_OPTIONS = ['move', 'delete']

export const DEFAULT_DOC_TITLE = 'Untitled'

export const PUBLISHED_ARTICLE_ID_PARAM = 'published_article_id'

export const DRAG_TYPES = {
  channel: 'channel',
  doc: 'doc',
}

export const ALMANAC_INTERNAL_COMPANY_NAME = 'Almanac'

export const CLOUDINARY_HOSTNAME = 'res.cloudinary.com'
export const GOOGLEUSERCONTENT_HOSTNAME = 'googleusercontent.com'
export const DEFAULT_COLORS = [
  StyleVariables.blue10,
  StyleVariables.gold10,
  StyleVariables.gray10,
  StyleVariables.green10,
  StyleVariables.navy10,
  StyleVariables.orange10,
  StyleVariables.pink10,
  StyleVariables.red10,
  StyleVariables.violet10,
]

export const NERUDA_SCHEMA_VERSION = 3

export const COMMENT_CREATION_ERROR_MESSAGE =
  'There was an issue saving your comment, if this issue persists, please contact support'

export const PAYWALL_CTA_THRESHOLD = 0.8
export const FREE_TRIAL_DAYS = 7

export const COMMON_TLDS: string[] = tlds

export const BLACK_FRIDAY_2023_DISMISSED = 'black_friday_2023_dismissed'
export const WEBINAR_REGISTRATION_URL = 'https://my.demio.com/ref/m3yjidEM28k8gbfw'
